import { v4 as uuidv4 } from 'uuid';

const BROWSER_UID_KEY = 'browser_uid';

export const getBrowserUid = () => {
    let browserUid = localStorage.getItem(BROWSER_UID_KEY);

    if (!browserUid) {
        browserUid = uuidv4();
        localStorage.setItem(BROWSER_UID_KEY, browserUid);
    }

    return browserUid;
};
